// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Kexx","location":"Header_location__1JIuw"};